<template>
  <div class="total bgps flex fd">
    <theader />
    <div class="content f1 flex" style="height: 98%;overflow: hidden;">
      <div class="f1 f11 flex fd" style="height: 100%;overflow: hidden;">
        <longbluetitle :titlearr="['工程车辆']" />
        <div class="icons flex jb">
          <div class="iconlist bgps flex">
            <img src="../assets/image/equipment/工程车辆.png" alt="" />
            <div class="f1 flex fd jb" style="padding: 0.26vw;margin-left: 7%;">
              <p style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #9BFBD3;">{{carData.deviceNum}}</p>
              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1rem;color: #D9E7FF;width: 7rem;">工程车数量</p>
            </div>
          </div>
          <div class="iconlist bgps flex">
            <img src="../assets/image/equipment/设备.png" alt="" />
            <div class="f1 flex fd jb" style="padding: 0.26vw;margin-left: 7%;">
              <p style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #9BFBD3;">{{carData.monitoringCoverageRate}}</p>
              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1rem;color: #D9E7FF;width: 7rem;">监控设备覆盖率</p>
            </div>
          </div>
        </div>
        <div class="maincontent" >
          <div class="tab" style="margin-bottom: 1.25rem">
            <tabs :namelist="namelist" @tabnum="tabnum"/>
          </div>
          <div class="maincontentlist">
            <div class="mainsingle flex pr" v-for="(i, j) in carList" v-if="carList.length>0">
              <img :src="i.installPic" alt="" />
              <div class="flex fd f1" style="margin-left: 3%;">
                <div
                    class="flex"
                    style="color: white; font-size: 0.89vw; margin-bottom: 10%;font-family: AlibabaPuHuiTi_2_85_Bold;font-style: normal;"
                >
                  <p class="f1">车牌号</p>
                  <p class="f1">{{ i.carNumber }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; margin-bottom: 2%; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">驾驶员</p>
                  <p class="f1">{{ i.driver }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; margin-bottom: 2%; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">工程车类型</p>
                  <p class="f1">{{ i.minorType }}</p>
                </div>
              </div>
              <div class=" pa flex jc ac" :class="i.status==='进场中'?'iswork':'onwork'" style="font-family: AlibabaPuHuiTi_2_85_Bold;color: #fff;">{{ i.status }}</div>
              <!-- <div class="onwork pa flex jc ac" v-else style="font-family: AlibabaPuHuiTi_2_85_Bold;color: #fff;">{{ i.status }}</div> -->

            </div>
            <div v-if="carList.length==0"  class="kongbox">
              <img src="../assets/image/暂无数据@2x.png" alt="">
              <p>暂无项目数据</p>
            </div>
          </div>
        </div>
      </div>
      <div class="f1 f11 flex fd" style="height: 100%;overflow: hidden;">
        <longbluetitle :titlearr="['施工升降梯']" />
        <div class="icons flex jb">
          <div class="iconlist bgps flex">
            <img src="../assets/image/equipment/升降梯.png" alt="" />
            <div class="f1 flex fd jb" style="padding: 0.26vw;margin-left: 7%;">
              <p style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #9BFBD3;">{{elevatorData.deviceNum}}</p>
              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1rem;color: #D9E7FF;width: 7rem;">升降梯数量</p>
            </div>
          </div>
          <div class="iconlist bgps flex">
            <img src="../assets/image/equipment/设备.png" alt="" />
            <div class="f1 flex fd jb" style="padding: 0.26vw;margin-left: 10%;">
              <p style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.7em;color: #9BFBD3;">{{
                  elevatorData.monitoringCoverageRate}}</p>
              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1rem;color: #D9E7FF;width: 7rem; ">监控设备覆盖率</p>
            </div>
          </div>
        </div>
        <div class="maincontent f1">
          <div class="maincontentlist flex fd" style="height: 100%;">
            <div
                class="mainsingle flex pr"
                v-for="(i, j) in elevatorData.elevatorList"
                style="height: 8.75vw"
            >
              <img :src="i.installPic" alt="" style="width: 7.29vw; height: 7.29vw" />
              <div class="flex fd f1" style="gap: 0.52vw;margin-left: 3%;">
                <div
                    class="flex"
                    style="color: white; font-size: 0.89vw; margin-bottom: 0.16vw;font-family: AlibabaPuHuiTi_2_85_Bold;font-style: normal;"
                >
                  <p class="f1">单位工程</p>
                  <p class="f1">{{ i.unitProject }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">安装时间</p>
                  <p class="f1">{{ i.installTime }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">最终使用高度</p>
                  <p class="f1">{{ i.finalHeight }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">载重限制</p>
                  <p class="f1">{{ i.limitWeight }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">人员限制</p>
                  <p class="f1">{{ i.limitPersonNumber }}人</p>
                </div>
                <div class=" pa flex jc ac" :class="i.status==='进场中'?'iswork':'onwork'" style="font-family: AlibabaPuHuiTi_2_85_Bold;color: #fff;">{{ i.status }}</div>

              </div>
            </div>
            <div v-if="elevatorData.elevatorList.length==0"  class="kongbox">
              <img src="../assets/image/暂无数据@2x.png" alt="">
              <p>暂无项目数据</p>
            </div>
          </div>
        </div>
      </div>
      <div class="f1 f11 flex fd" style="height: 100%;overflow: hidden;">
        <longbluetitle :titlearr="['塔式起重机']" />
        <div class="icons flex jb">
          <div class="iconlist bgps flex">
            <img src="../assets/image/equipment/塔吊.png" alt="" />
            <div class="f1 flex fd jb" style="padding: 0.26vw;margin-left: 7%;">
              <p style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #9BFBD3;">{{ this.deaderTotalList.todayWarningCount }}</p>
              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1rem;color: #D9E7FF;width: 7rem;">今日预警</p>
            </div>
          </div>
          <div class="iconlist bgps flex">
            <img src="../assets/image/equipment/设备.png" alt="" />
            <div class="f1 flex fd jb" style="padding: 0.26vw;margin-left: 7%;">
              <p style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #9BFBD3;">{{ this.deaderTotalList.onlineRate * 100  }}%</p>
              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1rem;color: #D9E7FF;width: 7rem;">设备在线率</p>
            </div>
          </div>
        </div>
        <div class="maincontent f1">
          <div class="maincontentlist flex fd" style="height: 100%;">
            <div
                class="mainsingle flex pr"
                v-for="(i, j) in craneData?.craneList"
                style="height: 8.75vw"
                @click="openTower(i,j)"
            >
              <img src="@/assets/image/位图备份@2x.png" alt="" style="width: 7.29vw; height: 7.29vw" />
              <div class="flex fd f1" style="gap: 0.42vw;margin-left: 3%;">
                <div
                    class="flex"
                    style="color: white; font-size: 0.89vw; margin-bottom: 0.16vw;font-family: AlibabaPuHuiTi_2_85_Bold;font-style: normal;"
                >
                  <p class="f1">{{ i.nickName }}塔吊</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">今日吊次</p>
                  <p class="f1">{{ i.todayLiftTimes }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">今日吊重</p>
                  <p class="f1">{{ i.todayLiftWeight }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">今日预警</p>
                  <p class="f1">{{ i.updateTime }}</p>
                </div>
                <div class="flex" style="color: #bbc6d6; font-size: 0.73vw;font-family: AlibabaPuHuiTi_2_55_Regular;">
                  <p class="f1">塔吊司机</p>
                  <p class="f1">{{ i.driverName }}</p>
                </div>

                <div class=" pa flex jc ac" :class="i.isOnline==='在线'?'tower-iswork':'tower-onwork'" style="font-family: AlibabaPuHuiTi_2_85_Bold;color: #fff;">{{ i.isOnline }}</div>

              </div>
            </div>
            <div v-if="!craneData.craneList || craneData.craneList.length==0"  class="kongbox">
              <img src="../assets/image/暂无数据@2x.png" alt="">
              <p>暂无项目数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tmenu />
    <el-dialog
        :visible.sync="dialogVisible"
        width="60%"
        class="no-header-dialog"
    >
      <div>
        <div class="customize-head">
          <div class="customize-title">实时监控数据</div>
          <div>
            <el-button
                class="custom-close-btn"
                icon="el-icon-close"
                @click="closeDrawer"
            />
          </div>
        </div>
        <div class="customize-body">
          <div class="bg-image">
            <div class="crane-data-image"></div>
            <div style="display: flex;height: 100%;">

              <div style="width: 55%; margin-left: 1.8vw; position: relative;">
                <div class="drawer-text" style="position: absolute; top: 17%; left: 15%;">
                  <span class="drawer-text">{{ formatDecimal(this.towerInfoList.loadRatio) || '- -' }}%</span>
                  <div class="drawer-title">荷载比</div>
                </div>
                <div class="drawer-text" style="position: absolute; top: 17%; left: 26%;">
                  <span class="drawer-text">{{ formatDecimal(this.towerInfoList.momentRatio )|| '- -' }}%</span>
                  <div class="drawer-title">力矩</div>
                </div>

                <div class="drawer-text" style="position: absolute; top: 29%; left: 78%;; display: flex; align-items: center;">
                  <span class="drawer-title" style="width: 40px; text-align: right; padding-right: 6px;">转角</span>
                  <span style="min-width: 50px; text-align: left;">{{ formatDecimal(this.towerInfoList.angle )|| '- -' }}°</span>
                </div>
                <div class="drawer-text" style="position: absolute; top: 42%; left: 78%; display: flex; align-items: center;">
                  <span class="drawer-title" style="width: 40px; text-align: right; padding-right: 6px;">倾角</span>
                  <span style="min-width: 50px; text-align: left;">{{ formatDecimal(this.towerInfoList.obliqueAngle )|| '- -' }}%</span>
                </div>

                <img src="@/assets/image/Group 1000015179@2x.png" alt="" style="position: absolute; top: 75%; right: 2%; width: 6.7vw; height: 1.3vw;">
                <div class="drawer-text" style="position: absolute; top: 74%; right: 6%; display: flex; align-items: center;">
                  <span class="drawer-title" style="width: 40px; text-align: right; padding-right: 6px;">风速</span>
                  <span style="min-width: 50px; text-align: left;">{{ formatDecimal(this.towerInfoList.windSpeed )|| '- -' }}m/s</span>
                </div>

                <div class="drawer-text" style="position: absolute; top: 76%; left: 6%;">
                  <span class="drawer-text">{{ formatDecimal(this.towerInfoList.payload) || '- -' }}T</span>
                  <div class="drawer-title">吊重</div>
                </div>
                <div class="drawer-text" style="position: absolute; top: 76%; left: 16%;">
                  <span class="drawer-text">{{ formatDecimal(this.towerInfoList.radius) || '- -' }}M</span>
                  <div class="drawer-title">幅度</div>
                </div>
                <div class="drawer-text" style="position: absolute; top: 76%; left: 27%;">
                  <span class="drawer-text">{{ formatDecimal(this.towerInfoList.loadRatio) || '- -' }}%</span>
                  <div class="drawer-title">荷载比</div>
                </div>

                <div style="position: absolute; top: 79%; right: 4%;" class="corner">
                  机械编码: {{ this.towerInfoList.equipmentNumber || '- -' }}
                </div>
                <div style="position: absolute; top: 82%; right: 4%;" class="corner">
                  型号: {{ this.towerInfoList.model || '- -' }}
                </div>
              </div>

              <div style="width: 43%">
                <div class="data-img"><span class="data-title">防护告知</span></div>
                <div style="display: flex;width: 100%;justify-content: space-between;">
                  <div class="inform-data">
                    <div class="warning">{{ this.warningCount }}<span style="padding-left: 2px">条</span></div>
                    <div class="inform-data-label">今日预警数</div>
                  </div>
                  <div class="inform-data">
                    <div class="police">{{ this.policeCount }}<span style="padding-left: 2px">条</span></div>
                    <div class="inform-data-label">今日报警数</div>
                  </div>
                  <div class="inform-data" style="margin-right: 1.6vw">
                    <div class="violation">{{ this.violationCount }}<span style="padding-left: 2px">条</span></div>
                    <div class="inform-data-label">今日违章数</div>
                  </div>
                </div>

                <div class="chart">
                  <div style="height: 120%;display: flex">
                    <echart :option="protectionNotice"></echart>
                  </div>

                </div>
                <div class="data-img"><span class="data-title">工作记录</span></div>
                <div class="chart">
                  <div style="height: 120%;display: flex;padding-left: 10px">
                    <echart :option="workRecord"></echart>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDeviceElevator,getmapTotalInfo ,getDeviceCar,getAlarmTrend,getTowerInfo,getworkRecord,getTowerHeaderTotal} from '@/utils/equipment';
import echart from '@/components/echart.vue';
export default {
  components: { echart},
  data() {
    return {
      warningCount:'',
      policeCount:'',
      violationCount:'',
      deaderTotalList:{},
      protectionNotice:{},
      workRecord:{},
      namelist: [
        { label: "全部", value: 0 },
        { label: "运渣车", value: 0 },
        { label: "挖掘机", value: 0},
        { label: "搅拌车", value: 0},
        { label: "泵车", value: 0},
      ],
      towerInfoList: {
        equipmentNumber: '',
        model: '',
        angle: null,
        obliqueAngle: null,
        windSpeed: null,
        loadRatio: null,
        momentRatio: null,
        payload: null,
        radius: null,
        towerHeight: null
      },
      tabnums:0,
      elevatorData:{},
      dialogVisible:false,
      craneData:{
        craneList: []
      },
      carData:{},
      carList:[]
    };
  },
  created(){
    this.getHeader()
    this.getElevator()
    this.getCrane()
    this.getCar()
  },
  mounted() {

  },
  methods: {
    formatDecimal(value) {
      if (value === null || value === undefined || value === '- -') {
        return '- -'
      }
      // 转换为数字并保留1位小数
      const num = Number(value)
      return isNaN(num) ? '- -' : num.toFixed(1)
    },
    getHeader(){
      getTowerHeaderTotal().then(res=>{
        this.deaderTotalList=res
      })
    },
    setworkRecord(){
      this.workRecord = {
        grid: {
          left: '0%',
          right: '2%',
          top: '20%',
          bottom: '20%',
          containLabel: true,
        },
        legend: [
          {
            data: ['重量(t)'],
            left: 0,
            top:10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              color: '#4E5969'
            }
          },
          {
            data: ['次数(次)'],
            right: 10,
            top:10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              color: '#4E5969'
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor :'none',
          padding:0,
          borderWidth: 0,
          formatter: (params,ticket)=>{
            let content = ''
            let total =0
            const colorMap = {
              '重量(t)': '#4BC0C0', // 黄色
              '次数(次)': '#9c7cfc', // 橙色
            }
            params.map(item=>{
              total+=item.value
              content+=`<li class='hover-item'><div style="display: flex;align-items: center;"><div class="hover-drop" style="background: ${colorMap[item.seriesName]}"></div><div>${item.seriesName}</div> </div><h2>${item.value}</h2></li>`
            })
            return `
          <div class='hover-wrap'>
              <div class='hover-header'>
                <h3>  ${params[0].axisValueLabel}</h3>
                <h2>${total}</h2>
                  </div>
                <div class='hover-content'>${content}</div>
          </div>`
          }
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255 , 255 , 255 ,0.15)',
                width: 1,
                type: 'dashed'
              }
            },
            nameTextStyle: {
              padding: [0, 40, 0, 0]
            },
            axisLabel: {
              interval: 0
            },
            interval: 500,
            min: 0,
            max: 1500
          },
          {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255 , 255 , 255 ,0.3)',
                width: 1,
                type: 'dashed'
              }
            },
            nameTextStyle: {
              padding: [0, 0, 0, 40]
            },
            axisLabel: {
              interval: 0
            },
            interval: 50,
            min: 0,
            max: 150
          }
        ],
        series: [
          {
            name: '重量(t)',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 0,
            itemStyle: {
              color: '#4BC0C0' // 设置线条和标记点的颜色（例如红色）
            },
          },
          {
            name: '次数(次)',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1
          }
        ]
      };

      getworkRecord(this.towerInfoList.equipmentNumber,).then(res => {
        this.workRecord.xAxis.data = res.xAxis.map(date => date.substring(5))
        this.workRecord.series[0].data=res.yCount
        this.workRecord.series[1].data=res.yMaxLoad
      });
    },
    closeDrawer(){
      this.dialogVisible=false
    },
    openTower(i,j){
      // console.log(111,i,j)
      this.dialogVisible=true
      // console.log(this. craneData.craneList,2123)
      getTowerInfo(i.equipmentNumber).then(res => {
        this.towerInfoList=res ||''
        this.setprotectionNotice()
        this.setworkRecord()
      })
    },
    setprotectionNotice() {
      this.protectionNotice = {
        grid: {
          left: '2%',
          right: '2%',
          top: '20%',
          bottom: '20%',
          containLabel: true,
        },
        legend: {
          data: ['预警', '报警', '违章'].map(name => ({
            name,
            icon: 'circle', // 强制指定为圆形
            symbol: 'circle' // 双保险
          })),
          right: 10,
          top: 10,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: 'rgba(137, 147, 161, 1)'
          },
          itemStyle: {
            borderWidth: 0
          },
          symbolKeepAspect: false
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor :'none',
          padding:0,
          borderWidth: 0,
          formatter: (params,ticket)=>{
            let content = ''
            let total =0
            const colorMap = {
              '预警': '#FFD700', // 黄色
              '报警': '#FFA500', // 橙色
              '违章': '#FF0000',  // 红色
            }
            params.map(item=>{
              total+=item.value
              content+=`<li class='hover-item'><div style="display: flex;align-items: center;"><div class="hover-drop" style="background: ${colorMap[item.seriesName]}"></div><div>${item.seriesName}</div> </div><h2>${item.value}</h2></li>`
            })
            return `
          <div class='hover-wrap'>
              <div class='hover-header'>
                <h3>  ${params[0].axisValueLabel}</h3>
                <h2>${total}</h2>
                  </div>
                <div class='hover-content'>${content}</div>
          </div>`
          }
        },
        yAxis: {
          type: 'value',
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0)',
              width: 1,
              type: 'dashed'
            }
          },
        },
        series: [] // 初始为空，等待接口数据填充
      };
      getAlarmTrend(this.towerInfoList.equipmentNumber).then(res => {
        this.protectionNotice.xAxis.data = res.xAxis.map(date => date.substring(5))|| [];
        this.protectionNotice.series = [
          {
            name: '预警',
            data: res.yAlarm0 || [0],
            type: 'bar',
            barWidth: 25,
            stack: 'total',
            itemStyle: this.getBarStyle(0)
          },
          {
            name: '报警',
            data: res.yAlarm1 || [0],
            type: 'bar',
            barWidth: 25,
            stack: 'total',
            itemStyle: this.getBarStyle(1)
          },
          {
            name: '违章',
            data: res.yAlarm2 || [0],
            type: 'bar',
            barWidth: 25,
            stack: 'total',
            itemStyle: this.getBarStyle(2)
          }
        ];

        this.warningCount = res.yAlarm0?.length ? res.yAlarm0[res.yAlarm0.length - 1] : 0;
        this.policeCount = res.yAlarm1?.length ? res.yAlarm1[res.yAlarm1.length - 1] : 0;
        this.violationCount = res.yAlarm2?.length ? res.yAlarm2[res.yAlarm2.length - 1] : 0;

      })
    },
    getBarStyle(type) {
      const colors = ['#FFC800', '#EF681C', '#FF0000']; // 黄、橙、红
      return {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [{
            offset: 0,
            color: colors[type]
          }],
          global: false
        }
      };
    },
    tabnum(e){
      const map = {
        0:[...this.carData.excavatorList,...this.carData.mixerList,...this.carData.pumpList,...this.carData.slagList],
        1:this.carData.slagList,
        2:this.carData.excavatorList,
        3:this.carData.mixerList,
        4:this.carData.pumpList
      }
      this.tabnums = e
      this.carList = map[e]
    },
    getElevator(){
      getDeviceElevator().then(res=>{
        this.elevatorData = res.data
      })
    },
    getCrane(){
      getmapTotalInfo().then(res=>{
        if(res.data.towerClusterRspList){
          this.craneData.craneList =  res.data.towerClusterRspList
        }else{
          this.craneData.craneList = []
        }

      })
    },
    getCar(){
      getDeviceCar().then(res=>{
        this.carData = res.data
        this.namelist = [
          { label: "全部", value: this.carData.deviceNum },
          { label: "运渣车", value: this.carData.slagNum },
          { label: "挖掘机", value: this.carData.excavatorNum },
          { label: "搅拌车", value: this.carData.mixerNum },
          { label: "泵车", value: this.carData.pumpNum},
        ]
        this.tabnum(0)
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.total {

  .content {
    .f11 {
      .maincontent {
        .maincontentlist {
          .mainsingle {
            .iswork {
              width: 5.375rem;
              height: 2.0625rem;
              background: linear-gradient(56deg, #00b4fb 0%, #0254a0 100%);
              border-radius: 0px 0.42vw 0px 0.73vw;
              top: 0;
              right: 0;
            }
            .onwork{
              width: 5.375rem;
              height: 2.0625rem;
              background: linear-gradient( 56deg, #F3AE42 0%, #9C5C15 100%);
              border-radius: 0px 0.42vw 0px 0.73vw;
              top: 0;
              right: 0;
            }
            img {
              width: 5.21vw;
              height: 5.21vw;
            }
            width: 100%;
            height: 9.375rem;
            background: #16385e;
            padding: 1.25rem;
            border-radius: .625rem;
            backdrop-filter: blur(5px);
            margin-bottom: .625rem;
          }
          width: 100%;
          height: 90%;
          overflow: auto;
          padding: 0 5%;
          .kongbox{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            >img{
              width:20%;
              margin-bottom: .625rem;
            }
          }
        }
        .tab {
          width: 100%;
          height: 5%;
        }
        width: 100%;
        height: 90%;
        overflow: hidden;
      }
      .icons {
        .iconlist {
          img {
            width: 4.32vw;
            height: 3.28vw;
          }
          width: 11.98vw;
          height: 100%;
          padding: 1.25vw 1.04vw 1.09vw 1.04vw;
          background: url("../assets/image/equipment/数字／匡备份.png")
          no-repeat;
        }
        width: 100%;
        height: 7.14vw;
        padding: 0.68vw 1.77vw 0.83vw 1.77vw;
      }
      background: rgba(0, 25, 49, 0.5);
      box-shadow: inset 0px 0px 24px 0px rgba(72, 125, 163, 0.5);
      border-radius: 8px;
      border: 1px solid rgba(131, 166, 199, 0.3);
      backdrop-filter: blur(14px);
      width: 32%;
      height: 98%;
      margin-right: 1%;
    }
    width: 100%;
    height: 90%;
    padding-left: 10.89vw;
    padding-right: 1.04vw;
    margin-top: 1.04vw;
  }
  width: 100%;
  height: 100%;
  background: url("../assets/image/bgstaff.png") no-repeat;
}
.customize-head{
  padding-left: 24px;
  width: 100%;
  height: 2.9vw;
  background: #1E3E62;
  border-radius: 0px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
  .customize-title{
    font-weight: 600;
    font-size: 16px;
    color: rgba(255,255,255,0.9);
    line-height:2.9vw;
  }
  .custom-close-btn{
    background: #1E3E62;
    border: 0;
    height: 100%;
  }
}
.customize-body {
  position: relative;
  width: 100%;
  height: 35.6vw;
}

.bg-image {
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/image/BG@2x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.crane-data-image {
  margin-left: 1.8vw;
  margin-top: 5.6vw;
  width: 55%;
  height: 70%;
  background-image: url('~@/assets/image/塔吊数据@2x.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
}
.drawer-text {
  font-weight: 600;
  font-size: 0.9vw;
  text-shadow: 0px -1px 6px rgba(64, 165, 254, 0.46);
  background: linear-gradient(180deg, #FFFFFF 41%, #54A9FF 96%, #0A85FF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.drawer-title{
  font-weight: 400;
  font-size: 0.7vw;
  letter-spacing: 1px;
  text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
color: rgba(217, 231, 255, 1)
}
::v-deep .no-header-dialog .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body{
  padding: 0;

}
::v-deep .el-dialog__footer{
  display: none;
}
.corner{
  font-weight: 400;
  color: rgba(217, 231, 255, 0.6);
  font-size: 14px;
  line-height: 22px;
}
.inform-data {
  width: 6.6vw;
  height: 3.5vw;
  background: url("../assets/image/equipment/数字／匡备份@2x.png") no-repeat;
  background-size: contain;

  .violation,
  .police,
  .warning {
    margin-left: 1.6vw;
    font-size: 1.3vw;
    font-weight: 500;
  }

  .violation { color: #FA4D56; }
  .police { color: #FFA20D; }
  .warning { color: #FFE8B5; }

  span {
    font-size: 0.7vw;
    color: #D9E7FF;
  }
}

.inform-data-label {
  margin-left: 1.6vw;
  font-size: 0.7vw;
  color: #D9E7FF;
}
.data-img{
  margin-top: 1.3vw;
  margin-bottom: 0.9vw;
  background: url('~@/assets/image/二级标题-背景.png') no-repeat;
  display: flex;
  height: 21px;
  }
.data-title{
  background: linear-gradient(270deg, #ACDDFF 0%, #FFFFFF 100%);
  background-clip: text;
  color: transparent;
  font-size: 15px;
  padding-left: 26px;
  font-weight: 500;
  line-height: 0.8;
  padding-top: 0.2vw;
  transform: translateY(-0.1vw);
}
.chart {
  position: relative;
  margin-top: 12px;
  width: 23.8vw;
  height: 11.6vw;
  background: rgba(0,25,49,0.5);
  border-radius: 8px 8px 8px 8px;
}

.chart::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  padding: 0.5px;
  background: linear-gradient(169deg, rgba(131, 166, 199, 0.5), rgba(64, 81, 97, 0));
  -webkit-mask: linear-gradient(#fff, #fff) content-box, linear-gradient(#fff, #fff);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}
.tower-iswork {
  width: 5.375rem;
  height: 2.0625rem;
  background: linear-gradient(56deg, #00b4fb 0%, #0254a0 100%);
  border-radius: 0px 0.42vw 0px 0.73vw;
  top: 0;
  right: 0;
}
.tower-onwork{
  width: 5.375rem;
  height: 2.0625rem;
  background: linear-gradient( 56deg, #39444D 0%, #4A5F73 100%);
  border-radius: 0px 0.42vw 0px 0.73vw;
  top: 0;
  right: 0;
}
::v-deep .hover-item{
  width: 128px;
  height: 32px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(113,135,161,0.27);
  color: #D9E7FF;
}
::v-deep .hover-wrap{
  width: 154px;
  padding:14px;
  background: rgba(31,58,84,0.95);
  box-shadow: 3px 4px 8px 0px rgba(64,64,64,0.3);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid;
}
::v-deep .hover-header{
  color: #D9E7FF;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  h3{
    font-weight: 500;
    font-size: 12px;
    color: #D9E7FF;
  }
  h2{
    font-size: 14px;
    color: #40D4FF;

  }
}
::v-deep .hover-content{
  width: 100%;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:4px;
  div{
    font-weight: 400;
    font-size: 12px;
    color: #D9E7FF;
  }
  h2{
    font-size: 14px;
    color: #40D4FF;
  }
}
::v-deep .hover-drop{
  width: 10px;
  height: 10px;
  border-radius: 10px 10px 10px 10px;
  margin-right: 4px;
}
</style>
